import { Scheme } from '@hogwarts/utils-schemes';
import React from 'react';

export const ConditionalScheme = React.createContext<Scheme | undefined>(
  undefined
);
